<template>
  <div id="kt_body" class="kt-body kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch">
    <div
      id="kt_content"
      class="kt-content kt-content--fit-top  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
    >
      <!-- begin:: Subheader -->
      <div id="kt_subheader" class="service-header kt-subheader kt-grid__item">
        <div class="kt-container ">
          <div class="kt-subheader__main header-section">
            <h3 class="kt-subheader__title">
              วิเคราะห์อารมณ์ในข้อความ
            </h3>
            <div class="subtitle">
              <div class="col-xl-6">
                วิเคราะห์อารมณ์ในข้อความว่าเป็นบวก, ลบ หรือกลาง
                <p>สามารถนำไปต่อยอดได้ เช่น การวิเคราะห์ feedback ของสินค้าหรือบริการ</p>
              </div>
              <div class="col-xl-6">
                <div class="kt-subheader__main">
                  <div class="kt-infobox__section service-info">
                    <div class="kt-infobox__subtitle kt-font-bold check-box-icon">
                      <i class="fa fa-check-circle" />
                    </div>
                    <div>
                      <div class="kt-infobox__subtitle kt-font-bold">
                        มี algorithm ให้เลือกหลายแบบ
                      </div>
                      <!-- <div class="kt-infobox__content">
                        เพื่อให้เหมาะกับประโยคจากบริบทที่แตกต่างกัน เช่น ข้อความจาก
                        <p>Social network/Chat หรือข้อความจากข่าว</p>
                      </div> -->
                    </div>
                  </div>
                  <div class="kt-infobox__section api-doc">
                    <a
                      href="https://nlp.insightera.co.th/docs/v1.0/#!/nlp/post_nlp_sentiment"
                      target="_blank"
                      class="kt-font-bolder api-doc-link"
                      @click="trackCustomEvent({ action: 'clicked', target: 'links_content', linkTo: 'docs' })"
                    >API Document</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end:: Subheader -->

      <!-- begin:: Content -->
      <div class="kt-container  kt-grid__item kt-grid__item--fluid">
        <div class="row">
          <div class="col-xl-6">
            <!--begin::Portlet-->
            <div class="kt-portlet kt-portlet--height-fluid">
              <!--begin::Form-->
              <form class="kt-form kt-form--label-right">
                <div class="kt-portlet__body">
                  <div class="kt-infobox">
                    <div class="title-wrapper kt-infobox__header">
                      <h3 class="kt-infobox__title">
                        พิมพ์ประโยคภาษาไทยที่นี่
                      </h3>
                      <div
                        class="algorithm-selector form-group row"
                        style="justify-content: flex-end;margin: auto 0 auto 0"
                      >
                        <label
                          for="exampleSelect1"
                          class="col-form-label kt-margin-r-10"
                        >วิธีวิเคราะห์อารมณ์</label>
                        <div class="">
                          <select
                            id="exampleSelect1"
                            v-model="selectedEngineCode"
                            :disabled="processing"
                            class="form-control"
                            @change="trackCustomEvent({ action: 'clicked', target: 'selector_content', value: selectedEngineCode }); submit()"
                          >
                            <option
                              v-for="(e, idx) in engines"
                              :key="idx"
                              :value="e.code"
                            >
                              {{ e.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="kt-infobox__body">
                      <!-- Address :: Text Input -->
                      <div class="form-group kt-margin-b-15">
                        <textarea
                          id="exampleTextarea"
                          v-model="text"
                          class="form-control"
                          rows="3"
                          @input="trackCustomEvent({ event: 'input', action: 'type', target: 'textarea_content', value: text })"
                        />
                      </div>
                      <div class="kt-form__actions kt-form__actions--right">
                        <div class="row">
                          <div class="col kt-align-left">
                            <button
                              type="button"
                              class="btn btn-secondary"
                              :disabled="processing"
                              @click="trackCustomEvent({ action: 'clicked', target: 'random_content' }); random()"
                            >
                              Random
                            </button>
                          </div>
                          <div class="col kt-align-right">
                            <button
                              type="button"
                              class="btn btn-primary kt-spinner--left kt-spinner--sm kt-spinner--light"
                              :class="{ 'kt-spinner' : processing }"
                              :disabled="processing"
                              @click="trackCustomEvent({ action: 'clicked', target: 'analyze_content' }); debounceSubmit()"
                            >
                              Analyze
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <!--end::Portlet-->
          </div>
          <div class="col-xl-6">
            <!--Begin:: Portlet-->
            <div class="kt-portlet kt-portlet--height-fluid">
              <div class="kt-portlet__body">
                <div class="kt-form kt-form--label-right">
                  <div class="kt-infobox">
                    <div class="kt-infobox__header">
                      <h3 class="kt-infobox__title">
                        วิเคราะห์อารมณ์ในข้อความ โดยวิธี {{ engineName }}
                      </h3>
                    </div>
                    <!-- Sentiment -->
                    <div class="kt-infobox__body">
                      <div class="kt-infobox__section">
                        <div class="kt-infobox__content">
                          วิเคราะห์อารมณ์ในข้อความ โดยวิธี {{ engineName }}
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-6">
                          <div class="kt-widget12">
                            <div class="kt-widget12__content">
                              <div class="kt-widget12__item">
                                <div class="kt-widget12__info">
                                  <span class="kt-widget12__desc kt-padding-b-0 kt-font-success">ชอบ</span>
                                  <div class="kt-widget12__progress">
                                    <div class="progress" style="height: 15px;">
                                      <div
                                        class="progress-bar bg-success"
                                        role="progressbar"
                                        :style="{width: pos+'%'}"
                                        aria-valuenow="97"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      />
                                    </div>
                                    <span class="kt-widget12__stat">
                                      {{ pos }}%
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <!-- <div class="kt-space-20" /> -->
                              <div class="kt-widget12__item">
                                <div class="kt-widget12__info">
                                  <span class="kt-widget12__desc kt-padding-b-0 kt-font-danger">ไม่ชอบ</span>
                                  <div class="kt-widget12__progress">
                                    <div class="progress" style="height: 15px;">
                                      <div
                                        class="progress-bar bg-danger"
                                        role="progressbar"
                                        :style="{width: neg+'%'}"
                                        aria-valuenow="3"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                      />
                                    </div>
                                    <span class="kt-widget12__stat">
                                      {{ neg }}%
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--End:: Portlet-->
          </div>
        </div>
      </div>
      <!-- end:: Content -->

      <!-- FeedbackModal -->
      <FeedbackModal :is-visible="isModalShow" />
    </div>
  </div>
</template>

<script>
import ws from '../ws'
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import FeedbackModal from '../components/FeedbackModal.vue'

export default {
  components: {
    FeedbackModal
  },
  data () {
    return {
      score: '...',
      textPool: [
        'ผมชอบไอเดียเขานะโอเคเลย',
        'ชอบมาก คิดได้ไง',
        'สินค้าไม่เหมือนที่โฆษณาเลย',
        'ไม่ประทับใจกับที่พักนี้เลย'
      ],
      text: '',
      processing: false,
      selectedEngineCode: '',
      engines: [
        {
          code: 'deepsent',
          name: 'Deepsent',
          desc: 'TODO:'
        },
        // {
        //   code: 'docsent',
        //   name: 'Docsent',
        //   desc: 'TODO:'
        // },
        // {
        //   code: 'vecsent_1',
        //   name: 'Vecsent 1',
        //   desc: 'TODO:'
        // },
        // {
        //   code: 'vecsent_2',
        //   name: 'Vecsent 2',
        //   desc: 'TODO:'
        // },
        {
          code: 'bagsent_1',
          name: 'Bagsent 1',
          desc: 'TODO:'
        }
        // {
        //   code: 'bagsent_2',
        //   name: 'Bagsent 2',
        //   desc: 'TODO:'
        // },
        // {
        //   code: 'scoring',
        //   name: 'Scoring',
        //   desc: 'TODO:'
        // }
      ],
      countAnalyze: 0,
      isSentFeedback: false
    }
  },
  computed: {
    ...mapGetters([
      'visitedPage'
    ]),
    isModalShow () {
      return this.countAnalyze === 3 && this.processing === false && this.isSentFeedback === false
    },
    engineName () {
      if (this.selectedEngineCode) {
        const engine = this.engines.find(e => e.code === this.selectedEngineCode)
        if (engine) {
          return engine.name
        }
      }
      return ''
    },
    neg () {
      return Math.round(((1 - this.score) / 2) * 100)
    },
    pos () {
      return Math.round(((1 + this.score) / 2) * 100)
    }
  },
  mounted () {
    this.selectedEngineCode = this.engines[0].code
    this.shuffle()
    this.random()
  },
  methods: {
    ...mapActions({
      trackCustomEvent: 'trackCustomEvent'
    }),
    shuffle () {
      for (let i = this.textPool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [this.textPool[i], this.textPool[j]] = [this.textPool[j], this.textPool[i]]
      }
      return this.textPool
    },
    random () {
      if (this.textPool.length > 0) {
        this.text = this.textPool.shift()
        this.textPool.push(this.text)
        this.submit()
      }
    },
    debounceSubmit: _.debounce(function () {
      this.countAnalyze += 1
      this.check()
      this.submit()
    }, 500, {
      leading: true
    }),
    async submit () {
      this.processing = true
      const result = await ws.sentiment(this.text, this.selectedEngineCode)

      const data = result.message

      this.score = data.sentiments[0].score
      this.processing = false
    },
    check () {
      Object.keys(this.visitedPage).map(key => {
        if (key === this.$route.name) {
          this.isSentFeedback = true
        }
      })
    }
  }
}
</script>

<style scoped>

  .kt-infobox__title {
    font-size: 22.75px;
  }

  .form-group label {
      font-size: 1.15rem;
  }

  textarea.form-control {
      font-size: 1.25rem;
  }

    /* .kt-subheader--transparent .kt-subheader .kt-subheader__main .kt-subheader__title {
        font-size: 2.5rem;
    } */

  .kt-infobox__content > span {
      line-height: 3rem;
  }

  .kt-widget12 .kt-widget12__content .kt-widget12__item .kt-widget12__info .kt-widget12__desc {
      font-size: 1.5rem;
  }

  .title-wrapper {
      -webkit-flex-wrap: wrap;
      justify-content: space-between;
      flex-wrap: wrap;
  }

  .title {
      flex-grow: 5;
  }

  .algorithm-selector {
      flex-grow: 3;
  }

    /* ----------------- */

  .kt-infobox__content > span {
    line-height: 2rem;
  }

  .header-section {
      width: 100%;
  }

  .kt-subheader {
      height: auto;
      padding-bottom: 0 !important;
  }

  .service-header {
    margin-bottom: 15px;
  }

  .subtitle {
      color: white !important;
      font-size: 1.25rem;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      margin-bottom: 10px;
      width: 100%;
  }

  .api-doc {
      margin-top: 10px;
      margin-left: 20px;
  }

  .api-doc-link {
      color: #d4cafd;
      text-decoration: underline;
  }

  .check-box-icon {
      margin-right: 5px;
  }

  .service-info {
      display: flex;
      margin-bottom: 10px;
  }

  .btn-primary {
      background-color: #6e51fa;
      transition: 0.3s;
  }

  .btn-primary:hover {
      background-color: #533bb3;
  }

  .service-header .kt-container {
    padding: 0em 5em 0 5em;
  }

</style>
